import React, { Component } from 'react'
import Input from './../input'
import Radio from './../radio'
import { PROTOCOL } from './../../lib/helper'
import _ from 'underscore'

class NexcessFormInputFields extends Component{
	constructor(props){
		super(props)
		this.state = {radio: "sftp"}
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
		this.onRadioClick = this.onRadioClick.bind(this)
	}

	onRadioClick(value) {
		this.setState({ radio: value })
	}

	getProtocol() {
		const { radio } = this.state
		if (radio === "sftp") {
			return PROTOCOL.SFTP
		} else {
			return PROTOCOL.FTPS
		}
	}

	fetchValue(key){
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	isFtpSelected(){
		const { radio } = this.state
		if (radio === "ftps") {
			return true
		} else {
			return false
		}
	}

	getClassName(key){
		const { errors } = this.props
		let classname = "col-md-12 col-xs-12"
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}

	render(){
		return (
			<div>
				<p className="bv-form-title" style={{textAlign: "left"}}>Enter sFTP Details of the new site that you want to migrate to</p>
				<div className="row">
					<div className={this.getClassName('newurl')}>
						<i className="mdi mdi-web"></i>
						<Input
							type="text"
							name="newurl"
							title="Destination Site URL"
							placeholder="Eg. www.google.com"
							classname=""
							value={this.fetchValue('newurl')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('type')}>
						<Radio
							name="type"
							title="FTP Type"
							items={['sftp', 'ftps']}
							value={this.fetchValue('type') || 'sftp'}
							widthClass="col-xs-4 col-md-4"
							iconClass="mdi mdi-clipboard-arrow-left"
							onClick={this.onRadioClick}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('address')}>
						<i className="mdi mdi-server"></i>
						<Input
							type="text"
							name="address"
							title="FTP Host/Server Address"
							placeholder="Eg. 127.0.0.1"
							classname=""
							value={this.fetchValue('address')}
						/>
					</div>
					<div className={this.getClassName('port')}>
						<Input
							style={{ paddingLeft: "1rem" }}
							type="number"
							name="port"
							title="Port"
							placeholder=""
							classname=""
							value={this.fetchValue('port')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('username')}>
						<i className="mdi mdi-account"></i>
						<Input
							type="text"
							name="username"
							title="FTP Username"
							placeholder="Enter FTP username here"
							classname=""
							value={this.fetchValue('username')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('passwd')}>
						<i className="mdi mdi-lock"></i>
						<Input
							type="password"
							name="passwd"
							title="FTP Password"
							placeholder="Enter FTP password here"
							classname=""
							value={this.fetchValue('passwd')}
						/>
					</div>
				</div>
				{ this.isFtpSelected() && <div className="row">
					<div className={this.getClassName('path')}>
						<i className="mdi mdi-folder"></i>
						<Input
							type="text"
							name="path"
							title="Directory Path"
							placeholder="Eg. /var/www/html"
							classname=""
							value={this.fetchValue('path')}
						/>
					</div>
				</div>}
				<div className="row hide-field">
					<Input
						type="hidden"
						name="migrate"
						value="nexcess"
						title=""
						placeholder=""
						classname=""
					/>
					<Input
						type="hidden"
						title=""
						name="protocol"
						placeholder=""
						classname=""
						value={this.getProtocol()}
					/>
					<Input
						type="hidden"
						title=""
						name="web_protocol"
						placeholder=""
						classname=""
						value="https://"
					/>
				</div>
			</div>
		)
	}
}

export default NexcessFormInputFields 
